
export class IndentItemsModel{
    indentItemId:number;
    plantId: number;
    farmer: number;
    farmerCode: number;
    product: number;
    expectedCount: number;
    expectedQty: number;
    expectedPrice: number;
    broker?: number;
    indentId?: number;
    createdUser?: string;
    createdAt?: Date;
    updatedUser?: string;
    updatedAt?: Date;

   
    /**
     * 
     * @param plantId 
     * @param farmer 
     * @param farmerCode 
     * @param product 
     * @param expectedCount 
     * @param expectedQty 
     * @param expectedPrice 
     * @param indentId
     * @param createdUser 
     * @param createdAt 
     * @param updatedUser 
     * @param updatedAt 
     */
    constructor(indentItemId:number,plantId: number,farmer: number,farmerCode: number,product: number,expectedCount: number,expectedQty: number,expectedPrice:number,broker?:number,
        indentId?: number,createdUser?: string,createdAt?: Date,updatedUser? : string,updatedAt?: Date){
       this.indentItemId = indentItemId;
       this.plantId = plantId;
       this.farmer = farmer;
       this.farmerCode = farmerCode;
       this.product = product;
       this.expectedCount = expectedCount;
       this.expectedQty = expectedQty;
       this.expectedPrice = expectedPrice;
       this.broker = broker;
       this.indentId = indentId;
       this.createdUser = createdUser;
       this.createdAt = createdAt;
       this.updatedUser = updatedUser;
       this.updatedAt = updatedAt;
    }
}